import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AccessRoute from "@/components/AccessRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Checkout from "@/pages/Checkout";
import TrialStart from "@/pages/TrialStart";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Journey from "@/pages/Journey";
import Lesson from "@/pages/Lesson";
import Checkin from "@/pages/Checkin";
import Completion from "@/pages/Completion";
import Track from "@/pages/Track";
import Toolkit from "@/pages/Toolkit";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import DoctorPlanner from "@/pages/DoctorPlanner";
import SupportPlan from "@/pages/SupportPlan";
import FinalDay from "@/pages/FinalDay";
import HotFlashDiary from "@/pages/HotFlashDiary";
import SleepJournal from "@/pages/SleepJournal";
import PrintableTracker from "@/pages/PrintableTracker";
import WeeklySummary from "@/pages/WeeklySummary";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/start" element={<TrialStart />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<Admin />} />
              <Route element={<AccessRoute />}>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/lesson/:day" element={<Lesson />} />
                <Route path="/checkin" element={<Checkin />} />
                <Route path="/complete/:day" element={<Completion />} />
                <Route path="/final" element={<FinalDay />} />
                <Route path="/doctor-planner" element={<DoctorPlanner />} />
                <Route path="/hot-flash-diary" element={<HotFlashDiary />} />
                <Route path="/sleep-journal" element={<SleepJournal />} />
                <Route path="/printable/:slug" element={<PrintableTracker />} />
                <Route path="/plan" element={<SupportPlan />} />
                <Route path="/summary/:week" element={<WeeklySummary />} />
                <Route element={<AppLayout />}>
                  <Route path="/home" element={<Home />} />
                  <Route path="/journey" element={<Journey />} />
                  <Route path="/track" element={<Track />} />
                  <Route path="/toolkit" element={<Toolkit />} />
                  <Route path="/profile" element={<Profile />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
